<template>
  <div>
    <div class="page-header"><h2>Venture Management</h2></div>
    <section class="page-content">
      <p>
        Are you presently an employee who has idea and willing to see it become
        a successful enterprise without resigning from your work? Then In CSVC
        we got your back as we understand the risks associated with being fully
        committed to seeing your ideas take shape as an entrepreneur.
      </p>
      <p>
        Hence we have well-seasoned managers who will be committed to helping
        you grow your business while you concentrate on your current engagement.
      </p>
      <p>Contact us today.</p>
    </section>
    <!-- use map array modifier to select only titles -->
    <ServiceForm :options-list="['Venture Management']" id="form"></ServiceForm>
  </div>
</template>

<script>
import ServiceForm from "./ServiceForm.vue";
export default {
  components: {
    ServiceForm
  }
};
</script>
